/* 🤖 this file was generated by svg-to-ts*/
export const iconTerritoryDermatology: {
  name: 'territory_dermatology';
  data: string;
} = {
  name: 'territory_dermatology',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M4.612 10.713l.533 1.138a3.166 3.166 0 005.83-.232l.067-.195.215-.711h3.742a1 1 0 01.117 1.993l-.117.007h-2.316a5.167 5.167 0 01-2.249 2.357l-.23.116a5.166 5.166 0 01-6.768-2.28l-.095-.194L1 12.713a1 1 0 01-.993-.883L0 11.713a1 1 0 01.883-.993L1 10.713h3.612zM9.15.066l-.224.711c-.566 1.778-.422 3.709-.085 5.406l.112.527.06.257.124.5.129.476.192.667.287.963.093.324.075.286c.055.222.087.4.087.528a2 2 0 11-4 0v-.055l.02-.155.04-.208.059-.257.163-.646.28-1.008.567-1.923.843-2.738.617-1.947.559-1.708z"/></svg>`,
};
